import React, { Component, Fragment } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { v4 } from 'uuid';
import Modal from 'react-modal';
import moment from 'moment';
import Dropdown from 'react-dropdown';
import { Helmet } from 'react-helmet';
import GoogleAnalytics from 'react-ga';
import { StickyShareButtons } from 'sharethis-reactjs';

import ServiceDetails, { getStopName, calculateDuration } from './service-list/ServiceDetails';
import Service from './service-list/Service';
import TopBar from './service-list/TopBar';
import TrackerTitle from '../components/TrackerTitle';
import DateTime from '../components/DateTime';
import ServiceTitle from '../components/ServiceTitle';
import StopsMap from './service-list/StopsMap';
import ServiceMap from './service-list/ServiceMap';

import { fetchServices, getName } from '../actions/ServicesAction';
import { fetchTicketInfo } from '../actions/TicketAction';

import { getTime, isEmptyObj } from '../helpers/Helpers';

import NXLogoBackground from '../assets/images/NX-logo-background.png';
import BusEireannLogoBackground from '../assets/images/bus-eireann/logo-grey.svg';
import DublinLogoBackground from '../assets/images/dublin-express/logo-grey.svg';
import MegaBusLogoBackground from '../assets/images/megabus/megabus-logo-background.svg';
import NXBusLogoBackground from '../assets/images/nxbus/nxbus-logo.png';
import WCCELogoBackground from '../assets/images/wcce/WCCE-logo-grey.svg';
import CityLinkLogoBackground from '../assets/images/citylink/citylink-logo-transparent.svg';

import IconClose from '../assets/images/ic-close.svg';
import DublinIconClose from '../assets/images/dublin-express/ic-close.svg';
import MegaBusIconClose from '../assets/images/megabus/ic-close.svg';
import NXBusIconClose from '../assets/images/nxbus/ic-close.svg';
import WCCEIconClose from '../assets/images/wcce/popup-close.svg';
import RegsCoachBtn from '../assets/images/regscoaches/ic-close.svg';
import PeterPanBtn from '../assets/images/peterpan/ic-close.svg';

import { THEME } from '../configs/global';

const embed = window.location.hostname.includes('-embed') || window.location.hostname.includes('-webview');

let gkey = THEME.GA.KEY ? THEME.GA.KEY : '';
if (window.location.hostname === 'coachtracker.nationalexpress.com')
  gkey = 'UA-22502992-7';

if (gkey)
  GoogleAnalytics.initialize(gkey);

Modal.setAppElement('#root');

const getLogoBackground = (name) => {
  switch (name) {
    case 'NX':
      return NXLogoBackground;
    case 'Bus-Eireann':
      return BusEireannLogoBackground;
    case 'Dublin-Express':
      return DublinLogoBackground;
    case 'Megabus':
      return MegaBusLogoBackground;
    case 'NX-Bus':
      return NXBusLogoBackground;
    case 'WCCE':
      return WCCELogoBackground;
    case 'Citylink':
      return CityLinkLogoBackground;
    default:
      return null;
  }
};

const getCloseIcon = (name) => {
  switch (name) {
    case 'NX':
      return IconClose;
    case 'Bus-Eireann':
      return IconClose;
    case 'Dublin-Express':
      return DublinIconClose;
    case 'Megabus':
      return MegaBusIconClose;
    case 'NX-Bus':
      return NXBusIconClose;
    case 'WCCE':
      return WCCEIconClose;
    case 'Regscoaches':
      return RegsCoachBtn;
    case 'Peterpan':
      return PeterPanBtn;
    
    default:
      return IconClose;
  }
};

const getTitleLabel = (name) => {
  switch (name) {
    case 'NX':
      return 'National Express Coach Tracker';
    case 'Bus-Eireann':
      return 'Bus-Eireann Coach Tracker';
    case 'Dublin-Express':
      return 'Dublin Express Coach Tracker';
    default:
      return name;
  }
};

const stylesModal = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, .4)',
    zIndex: 99999
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '305px',
    height: '380px',
    padding: '28px 30px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '1px solid #B6BECC',
    borderRadius: 10,
    boxShadow: '0 0 8px 0 rgba(52,63,82,0.1)',
  },
};

const stylesModalInfo = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, .4)',
    zIndex: 99999
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '305px',
    height: '280px',
    padding: '28px 30px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '1px solid #B6BECC',
    borderRadius: 10,
    boxShadow: '0 0 8px 0 rgba(52,63,82,0.1)',
  },
};

const spaceBetween = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const getServices = (services, future) => {
  if (!!(services && services.stops[0].chronological_departures.length)) {
    if (THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0])) {
      return services.stops[0].chronological_departures.filter((service, index) => {
        if (!service.from_stop && service.stop) {
          service.from_stop = service.stop;
          if (services.stops[0].chronological_departures.length > index + 2)
            services.stops[0].chronological_departures[index + 2].from_stop = services.stops[0].chronological_departures[index + 2].stop;
        }

        let showdepart = false;
        if ((services.stops[0].chronological_departures.length > index + 2 && services.stops[0].chronological_departures[index + 2].from_stop && services.stops[0].chronological_departures[index + 2].from_stop.estimated_departure_time_formatted_local))
          showdepart = true;

        let currDatehour = Math.round(Date.now() / 1000);
        service.sortseconds = service.from_stop.estimated_departure_time_unix ? service.from_stop.estimated_departure_time_unix : service.from_stop.live_departure_time_unix ? service.from_stop.live_departure_time_unix : service.from_stop.scheduled_departure_time_unix;
        //const datetime = (service.from_stop.estimated_departure_time_unix ? service.from_stop.estimated_departure_time_unix : service.from_stop.scheduled_arrival_time_unix ? service.from_stop.scheduled_arrival_time_unix : service.trip.departure_time_unix);
        const date = moment(service.trip.departure_time_formatted_local).startOf('day').unix();
        const currDate = moment().startOf('day').unix();
        
        if (service.sortseconds > (currDatehour + 3600))
          service.coachtracker.is_later_departure = true;
        if (service.sortseconds < currDatehour && !showdepart)
          service.coachtracker.is_earlier_departure = true;
        else service.coachtracker.is_earlier_departure = false;
        return service.trip.duplicate_service ? null : future
          ? date > currDate
          : currDate === date;
      }).sort((a, b) => (a.sortseconds >= b.sortseconds) ? 1 : -1);
    } else {
      return services.stops[0].chronological_departures.filter((service) => {
        const date = moment(service.trip.departure_time_formatted_local).startOf('day').unix();
        const currDate = moment().startOf('day').unix();
        return service.trip.duplicate_service ? null : future
          ? date > currDate
          : currDate === date;
      });
    }
  }

  return [];
};


const getEmailHash = (pathname) => {
  const parts = pathname.split('/');
  if (parts.length > 3) {
    return parts[2];
  } else {
    const startIndex = pathname.indexOf('et') + 3;
    const endIndex = pathname.lastIndexOf('/');

    let email = pathname.substring(startIndex, endIndex);

    if (email.indexOf('/route') === -1) {
      return email;
    }

    return (email = pathname.substring(startIndex, endIndex));
  }
};

const getTicketNumber = (pathname) => {
  const parts = pathname.split('/');
  if (parts.length > 3) {
    return parts[3];
  } else {
    const startIndex = pathname.lastIndexOf('/') + 1;

    let ticketNumber = pathname.slice(startIndex);

    if (ticketNumber.indexOf('/route') === -1) {
      return ticketNumber;
    }

    return (ticketNumber = pathname.substring(
      startIndex,
      pathname.indexOf('/', startIndex)
    ));
  }
};

const mapStateToProps = (state) => ({
  services: state.services,
  isMobileScreen: state.mobileScreen,
  routes: !!state.services.stops && [
    'All',
    ...state.services.stops[0].chronological_departures
      .map((el) => el.trip.route_id)
      .filter((v, i, a) => a.indexOf(v) === i)
      .sort(),
  ],
  ticket: state.ticket,
  outbound: state.ticket && state.ticket.legs &&
    state.ticket.legs.filter((obj => !obj.is_return_leg)),
  inbound: state.ticket && state.ticket.legs &&
    state.ticket.legs.filter((obj => obj.is_return_leg))
});

class ServiceList extends Component {
  constructor(props) {
    super(props);
    this.selectorRef = React.createRef(null);
  }

  state = {
    isStops: false,
    isInfoModalOpen: false,
    isFreqInfoModalOpen: false,
    isCancelledInfoModalOpen: false,
    station: {},
    showTabs: true,
    showMain: true,
    futureServices: [],
    todayServices: [],
    filterValue: undefined,
    tabIndex: 0,
    showPrevCoach: false,
    showNextCoach: false,
  };

  async loadData(match, pathname) {
    if (pathname.indexOf('ticket-by-email') !== -1) {
      this.props.fetchTicketInfo(
        match.params.ticketid,
        match.params.email,
        null
      );
    } else if (pathname.indexOf('ticket') !== -1) {
      this.props.fetchTicketInfo(
        getTicketNumber(pathname),
        null,
        getEmailHash(pathname)
      );
    } else if (pathname.indexOf('debug-trip') !== -1) {
      this.props.fetchServices(
        undefined,
        undefined,
        'debug',
        undefined,
        undefined,
        this.mapServiceToState
      );
    } else {
      if (match.params) {
        if (match.params.from && match.params.to) {
          this.props.fetchServices(
            match.params.from,
            match.params.to,
            'between',
            undefined,
            undefined,
            this.mapServiceToState
          );
        } else if (match.params.reference) {
          this.props.fetchServices(
            match.params.reference,
            0,
            'reference',
            undefined,
            undefined,
            this.mapServiceToState
          );
        } else if (match.params.service) {
          this.props.fetchServices(
            match.params.service,
            0,
            'service',
            undefined,
            undefined,
            this.mapServiceToState
          );
        } else if (match.params.stop) {
          this.props.fetchServices(
            match.params.stop,
            0,
            'stop',
            undefined,
            undefined,
            this.mapServiceToState
          );
        }
      }
    }
  }
  async componentDidMount() {
    const {
      match,
      history: {
        location: { pathname },
      },
    } = this.props;

    this.loadData(match, pathname);

    this.selectorRef.current = setInterval(async () => { this.loadData(match, pathname)} , 60000);
  }

  componentWillUnmount() {
    clearInterval(this.selectorRef.current);
  }
  componentDidUpdate(prevProps) {
    const {
      match,
      isMobileScreen,
      outbound,
      inbound,
      ticket,
      history: {
        location: { pathname },
      },
    } = this.props;
    if (
      prevProps.isMobileScreen.detailView !== isMobileScreen.detailView ||
      prevProps.location.path !== this.props.location.path
    ) {
      if (isMobileScreen.open && isMobileScreen.detailView) {
        this.setState({
          showTabs: false,
        });
      } else {
        this.setState({
          showTabs: true,
        });
      }
    }

    if (prevProps.isShowSearch !== this.props.isShowSearch) {
      if (isMobileScreen.open && !this.props.isShowSearch) {
        this.setState({
          showMain: false,
        });
      } else {
        this.setState({
          showMain: true,
        });
      }
    }

    if (
      prevProps.match.params.from !== match.params.from ||
      prevProps.match.params.to !== match.params.to ||
      prevProps.match.params.reference !== match.params.reference ||
      prevProps.match.params.service !== match.params.service ||
      prevProps.match.params.stop !== match.params.stop
    ) {
      clearInterval(this.selectorRef.current);
      this.selectorRef.current = setInterval(async () => {this.loadData(match, pathname)} , 60000);
      
      this.setState({
        tabIndex: 0,
        filterValue: 'All',
      });
      if (pathname.indexOf('ticket') !== -1) {
        this.props.fetchTicketInfo(
          getTicketNumber(pathname),
          getEmailHash(pathname)
        );
      } else {
        if (match.params.from && match.params.to) {
          this.props.fetchServices(
            match.params.from,
            match.params.to,
            'between',
            undefined,
            undefined,
            this.mapServiceToState
          );
        } else if (match.params.reference) {
          this.props.fetchServices(
            match.params.reference,
            0,
            'reference',
            undefined,
            undefined,
            this.mapServiceToState
          );
        } else if (match.params.service) {
          this.props.fetchServices(
            match.params.service,
            0,
            'service',
            undefined,
            undefined,
            this.mapServiceToState
          );
        } else if (match.params.stop) {
          this.props.fetchServices(
            match.params.stop,
            0,
            'stop',
            undefined,
            undefined,
            this.mapServiceToState
          );
        }
      }
    }

    if (prevProps.ticket !== ticket) {
      let tindex = this.state.tabIndex;
      if (pathname.indexOf('ticket') !== -1) {

        if (!isEmptyObj(ticket)) {
          let idiff = -1;
          let odiff = -1;
          if (inbound && inbound.length)
            for (let i = 0; i < inbound.length; i++) {
              let diff = Math.abs(
                moment().diff(moment(inbound[i].from_stop.scheduled_departure_time_formatted_local))
              );
              if (diff < idiff || idiff === -1) {
                idiff = diff;
              }
            }
          if (outbound && outbound.length)
            for (let i = 0; i < outbound.length; i++) {
              let diff = Math.abs(
                moment().diff(
                  moment(outbound[i].from_stop.scheduled_departure_time_formatted_local)
                )
              );
              if (diff < odiff || odiff === -1) {
                odiff = diff;
              }
            }
          if ((idiff < odiff && odiff !== -1 && inbound && inbound.length) || ((!outbound || !outbound.length) && inbound && inbound.length))
            tindex = 1;
          else tindex = 0;
        }
      }
      this.setState({
        tabIndex: tindex,
      });
    }
  }

  mapServiceToState = (res) => {
    let todayServices = getServices(res);
    let futureServices = getServices(res, true);
    this.setState({
      todayServices: todayServices,
      futureServices: futureServices,
      filterValue: undefined,
      todayRoutes: !!todayServices.length && [
        'All',
        ...todayServices
          .map((el) => el.trip.route_id)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort(),
      ],
      todayDestinations: !!todayServices.length && [
        'All',
        ...todayServices
          .map((el) => el.trip.arrival_location_name)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort(),
      ],
      futureRoutes: !!futureServices.length && [
        'All',
        ...futureServices
          .map((el) => el.trip.route_id)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort(),
      ],
      futureDestinations: !!futureServices.length && [
        'All',
        ...futureServices
          .map((el) => el.trip.arrival_location_name)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort(),
      ],
    });
  };

  showServiceDetails = (service, mapcall = false) => (e) => {
    if (mapcall)
      this.setState({
        tabIndex: 0,
      });

    if (!service.trip && !service.trackable_trip)
      return false;
    this.myCallback(null);
    this.tabCallback(0);
    const {
      route_id,
      direction,
      departure_time_formatted_local,
    } = service.trackable_trip ? service.trackable_trip : service.trip;

    if (this.props.isMobileScreen.open) {
      this.setState({
        showTabs: false,
      });
    }

    if (!e.latlng)
      e.preventDefault();

    const { match, history } = this.props;
    const journeyId = moment(departure_time_formatted_local).format('HHmm');
    const linkDate = moment(departure_time_formatted_local).format('DD-MM-YYYY');
    const mapView = history.location.pathname.indexOf('map') !== -1;
    const maplink = mapView ? '/map' : '';
    if (history.location.pathname.indexOf('ticket') !== -1) {
      history.push(
        `/ticket/${match.params.hash}/${match.params.email}/${service.from_stop_tracking.internal_id}/${service.to_stop_tracking.internal_id}/route/${route_id}/${direction}/${journeyId}/${linkDate}${maplink}`
      );
    } else if (history.location.pathname.indexOf('reference') !== -1) {
      history.push(
        `/view/reference/${match.params.reference}/route/${route_id}/${direction}/${journeyId}/${linkDate}${maplink}`
      );
    } else if (history.location.pathname.indexOf('stop') !== -1) {
      history.push(
        `/view/stop/${match.params.stop}/route/${route_id}/${direction}/${journeyId}/${linkDate}${maplink}`
      );
    } else if (history.location.pathname.indexOf('service') !== -1) {
      history.push(
        `/view/service/${match.params.service}/route/${route_id}/${direction}/${journeyId}/${linkDate}${maplink}`
      );
    } else {
      history.push(
        `/view/between/${match.params.from}/${match.params.to}/route/${route_id}/${direction}/${journeyId}/${linkDate}${maplink}`
      );
    }
    return true;
  };

  navigateTo = (e) => {
    e.preventDefault();

    const { isMobileScreen, history, match, hideMap, clearSearch } = this.props;

    if (isMobileScreen.open && isMobileScreen.detailView) {
      if (match.params.reference)
        history.push(`/view/reference/${match.params.reference}`);
      else if (match.params.stop)
        history.push(`/view/stop/${match.params.stop}`);
      else if (match.params.service)
        history.push(`/view/service/${match.params.service}`);
      else if (match.params.to)
        history.push(`/view/between/${match.params.from}/${match.params.to}`);
      else history.push(`/`);
      this.setState({
        showTabs: true,
      });

      return undefined;
    }

    hideMap();

    clearSearch(true);

    history.push('/');
  };

  showStops = (open) => {
    this.setState({
      isStops: open,
    });
  };

  toggleInfoModal = (obj) => (e) => {
    e.stopPropagation();
    this.setState({
      isInfoModalOpen: !this.state.isInfoModalOpen,
      station: obj,
    });
  };

  toggleFreqInfoModal = () => (e) => {
    e.stopPropagation();
    this.setState({
      isFreqInfoModalOpen: !this.state.isFreqInfoModalOpen,
    });
  };

  toggleCancelledInfoModal = () => (e) => {
    e.stopPropagation();
    this.setState({
      isCancelledInfoModalOpen: !this.state.isCancelledInfoModalOpen,
    });
  };

  closeModal = (e) =>
    this.setState({
      isInfoModalOpen: false,
      isFreqInfoModalOpen: false,
      isCancelledInfoModalOpen: false
    });

  filterSelect = (obj) => {
    this.setState({
      todayServices: getServices(this.props.services).filter((el) => {
        return 'All' === obj.value
          ? el
          : el.trip.route_id === obj.value || el.trip.short_name === obj.value || el.trip.arrival_location_name === obj.value
          ? el
          : '';
      }),
      futureServices: getServices(this.props.services, true).filter((el) => {
        return 'All' === obj.value
          ? el
          : el.trip.route_id === obj.value || el.trip.short_name === obj.value || el.trip.arrival_location_name === obj.value
          ? el
          : '';
      }),
      filterValue: obj.value,
    });
  };

  myCallback = (dataFromChild) => {
    this.setState({
      listDataFromChild: dataFromChild,
    });
  };

  tabCallback = (dataFromChild) => {
    this.setState({
      detailstabindex: dataFromChild,
    });
  };

  togglePrevCoach = (e) => {
    this.setState({
      showPrevCoach: !this.state.showPrevCoach,
    });
  };

  toggleNextCoach = (e) => {
    this.setState({
      showNextCoach: !this.state.showNextCoach,
    });
  };

  render() {
    if (
      this.props.match.params.from === 'undefined' &&
      this.props.match.params.to === 'undefined' &&
      this.props.match.params.reference === 'undefined' &&
      this.props.match.params.stop === 'undefined' &&
      this.props.match.params.service === 'undefined'
    ) {
      return <Redirect to="/" />;
    }

    const {
      services,
      isMobileScreen,
      isShowSearch,
      route,
      history,
      ticket,
      match,
      inbound,
      outbound
    } = this.props;
    if (
      match.params.reference &&
      services.services.length &&
      history.location.pathname.indexOf('route') === -1
    ) {
      history.push(
        `/view/reference/${match.params.reference}/route/${services.services[0].route}/${services.services[0].dir}/${services.services[0].journeyId}/${services.services[0].linkDate}`
      );
    }

    const {
      isStops,
      isInfoModalOpen,
      isFreqInfoModalOpen,
      isCancelledInfoModalOpen,
      showTabs,
      showMain,
      todayServices,
      futureServices,
      showPrevCoach,
      showNextCoach,
      todayRoutes,
      futureRoutes,
      todayDestinations,
      futureDestinations,
    } = this.state;
    
    const station = (this.state.station.message && this.state.station.message === 'OK') ? this.state.station : this.props.station;
    
    let fromStop = station.stops ? station.stops[0] : null;
    let toStop = station.stops ? station.stops[station.stops.length - 1] : null;
    if (toStop)
      for (let i = 0; i < station.stops.length; i++) {
        if (station.stops[i].must_contain_stop_ids_index === 0) fromStop = station.stops[i];
        if (station.stops[i].must_contain_stop_ids_index === 1) toStop = station.stops[i];
      }

    const currDate = moment(
      route && route.trip && route.trip.departure_time_formatted_local
    ).format('ddd D MMMM YYYY');

    const searchByTicket = history.location.pathname.indexOf('ticket') !== -1;
    const mapView = history.location.pathname.indexOf('map') !== -1;

    const dateFormat = isMobileScreen.open
      ? 'ddd D MMM YYYY'
      : THEME.NAME === 'Megabus'
      ? 'ddd D MMM YYYY'
      : 'ddd D MMMM YYYY';

    !!searchByTicket &&
      outbound &&
      outbound.length &&
      GoogleAnalytics.event({
        category: 'inboundServicesLegCount',
        action: String(outbound.length),
      });
    !!searchByTicket &&
      inbound &&
      inbound.length &&
      GoogleAnalytics.event({
        category: 'outboundServicesLegCount',
        action: String(inbound.length),
      });

    if (typeof window.__sharethis__ !== 'undefined') {
      window.__sharethis__.href = window.location.href;
    }

    return (
      <Fragment>
        {showMain && (
          <div className={`main__results ${
            services.stops && services.stops.length && (THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0]))
              ? 'results__details--highfrequency'
              : ''
            }`}>
            <TopBar title="Search again" onClick={this.navigateTo} />

            <TopBar
              title="Search again"
              className="navlink--back"
              onClick={this.navigateTo}
            />

            <div className="results">
              {showTabs && (
                <Tabs
                  selectedIndex={this.state.tabIndex}
                  onSelect={(tabIndex) => this.setState({ tabIndex })}
                >
                  <TabList>
                    <Tab>{searchByTicket ? 'Outbound' : services.stops && (THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0])) ? 'List' : 'Today'}</Tab>
                    <Tab>{searchByTicket ? 'Inbound' : services.stops && (THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0])) ? 'Map' : 'Tomorrow'}</Tab>
                  </TabList>

                  <TabPanel>
                    {searchByTicket && ticket.legs ? (
                      <TrackerTitle
                        date={
                          ticket.legs.length
                            && moment(ticket.legs[0].from_stop.scheduled_departure_time_formatted_local).format('DD/MM/YYYY')
                        }
                      >
                        Ticket Number: {getTicketNumber(history.location.pathname)}
                      </TrackerTitle>
                    ) : (
                      <TrackerTitle>{!THEME.REALTIME ? 'Services' : 'Live Tracking'}</TrackerTitle>
                    )}

                    {!searchByTicket && !!(services) && (
                      <Fragment>
                        <Helmet>
                          <title>
                            {services.to_stops_metadata && services.to_stops_metadata.length
                              ? `Search Results from ${services.stops[0].metadata.public_facing_name} to ${services.to_stops_metadata[0].public_facing_name} - ${getTitleLabel(
                                  THEME.NAME
                                )}`
                              : services.stops && services.stops.length
                              ? `Search Results from ${getName(services, 0)}`
                              : match.params.reference
                              ? `Search Results for reference ${match.params.reference}`
                              : match.params.service
                              ? `Search Results for service ${match.params.service}`
                              : `Search Results`}
                          </title>
                        </Helmet>
                        {services.to_stops_metadata && services.to_stops_metadata.length ? (
                          <ServiceTitle>
                            {services.stops[0].metadata.public_facing_name.substring(
                              0,
                              services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                            )}
                            <span className="subName">
                              {services.stops[0].metadata.public_facing_name.substring(
                                services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                              )}
                            </span>
                            <span className="to"></span>{' '}
                            <span>
                              {services.to_stops_metadata[0].public_facing_name.substring(
                                0,
                                services.to_stops_metadata[0].public_facing_name.indexOf(':') + 1
                              )}
                              <span className="subName">
                                {services.to_stops_metadata[0].public_facing_name.substring(
                                  services.to_stops_metadata[0].public_facing_name.indexOf(':') + 1
                                )}
                              </span>
                            </span>
                          </ServiceTitle>
                        ) : services.stops && services.stops.length && services.stops[0].metadata && services.stops[0].metadata.public_facing_name ? (
                          <ServiceTitle>
                            {services.stops[0].metadata.public_facing_name.substring(
                              0,
                              services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                            )}
                            <span className="subName">
                              {services.stops[0].metadata.public_facing_name.substring(
                                services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                              )}
                            </span>
                          </ServiceTitle>
                        ) : match.params.reference ? (
                          <ServiceTitle>
                            <div>Reference: {match.params.reference}</div>
                          </ServiceTitle>
                        ) : match.params.service ? (
                          <ServiceTitle>
                            <div>{THEME.SERVICE_SHORT_TEXT ? THEME.SERVICE_SHORT_TEXT : 'Service'}: {match.params.service}</div>
                          </ServiceTitle>
                        ) : (
                          <ServiceTitle>
                            <div>Not Found</div>
                          </ServiceTitle>
                        )}
                      </Fragment>
                    )}

                    {searchByTicket && !isEmptyObj(ticket) && (
                      <ServiceTitle>
                        {outbound && outbound.length ?
                          <Fragment>
                          {
                            outbound[0].from_stop.public_facing_name
                          }{' '}
                          <span className="to"></span>
                          <span>
                            {
                              outbound[0].to_stop.public_facing_name
                            }
                          </span>
                          <Helmet>
                            <title>
                              {THEME.NAME !== 'NX'
                                ? THEME.TITLE
                                : `View Ticket from${' '}
                                ${
                                  outbound[0].from_stop.public_facing_name
                                } to${' '}
                                ${
                                  outbound[0].to_stop.public_facing_name
                                } -
                                National Express Coach Tracker`}
                            </title>
                          </Helmet>
                        </Fragment>  : (
                          'No booked journey'
                        )
                        }
                      </ServiceTitle>
                    )}
                    
                    {!searchByTicket &&
                      !!(
                        services &&
                        services.stops &&
                        services.stops.length
                      ) && (
                        <div style={spaceBetween}>
                          <DateTime
                            date={moment(services.stops[0].chronological_departures.departure_time_formatted_local).format(dateFormat)}
                          />
                          {(THEME.SHOW_TABS && ((match.params.service &&
                            todayDestinations &&
                            todayDestinations.length > 1) ||
                            (todayRoutes && todayRoutes.length > 1))) && (
                            <Dropdown
                              options={
                                match.params.service
                                  ? todayDestinations
                                  : todayRoutes
                              }
                              onChange={this.filterSelect}
                              value={this.state.filterValue}
                              placeholder={
                                match.params.service
                                  ? 'Filter Destination'
                                  : 'Filter Service'
                              }
                            />
                          )}
                        </div>
                      )}

                    <div>
                      
                      {!searchByTicket && !!todayServices.length && (
                        !mapView ? (
                          <Fragment>
                            {todayServices.some(
                              (service) => service.coachtracker.is_earlier_departure
                            ) && todayServices.length >= 6 && (
                              <button
                                className={`btn-show-coach ${
                                  showPrevCoach ? 'btn-show-coach--down' : ''
                                }`}
                                onClick={this.togglePrevCoach}
                              >{`${showPrevCoach ? 'Hide' : ''} ${
                                THEME.NAME === 'NX-Bus'
                                  ? 'EARLIER BUSES'
                                  : 'Earlier coaches'
                              }`}</button>
                            )}
                            {todayServices.map((obj) => {
                              let service;
                              if (showPrevCoach && showNextCoach) {
                                service = (
                                  <Service
                                    key={v4()}
                                    service={obj}
                                    showServiceDetails={this.showServiceDetails}
                                    detailstabindex={this.tabCallback}
                                    toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                    showChange={
                                      todayServices.length > 1 ? true : false
                                    }
                                    future={false}
                                  />
                                );
                              } else if (
                                showPrevCoach &&
                                obj.coachtracker.is_earlier_departure
                              ) {
                                service = (
                                  <Service
                                    key={v4()}
                                    service={obj}
                                    showServiceDetails={this.showServiceDetails}
                                    detailstabindex={this.tabCallback}
                                    toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                    showChange={
                                      todayServices.length > 1 ? true : false
                                    }
                                    future={false}
                                  />
                                );
                              } else if (
                                showNextCoach &&
                                obj.coachtracker.is_later_departure
                              ) {
                                service = (
                                  <Service
                                    key={v4()}
                                    service={obj}
                                    showServiceDetails={this.showServiceDetails}
                                    detailstabindex={this.tabCallback}
                                    toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                    showChange={
                                      todayServices.length > 1 ? true : false
                                    }
                                    future={false}
                                  />
                                );
                              } else if (
                                (!obj.coachtracker.is_later_departure && !obj.coachtracker.is_earlier_departure) ||
                                  (todayServices.length < 6)
                              ) {
                                service = (
                                  <Service
                                    key={v4()}
                                    service={obj}
                                    showServiceDetails={this.showServiceDetails}
                                    detailstabindex={this.tabCallback}
                                    toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                    showChange={
                                      todayServices.length > 1 ? true : false
                                    }
                                    future={false}
                                  />
                                );
                              }
                              return service;
                            })}
                            {
                              todayServices.length >= 6 &&
                              todayServices.some(
                                (service) => service.coachtracker.is_later_departure
                              ) && (
                                <button
                                  className={`btn-show-coach ${
                                    !showNextCoach ? 'btn-show-coach--down' : ''
                                  }`}
                                  onClick={this.toggleNextCoach}
                                >{`${!showNextCoach ? '' : 'Hide'} ${
                                  THEME.NAME === 'NX-Bus'
                                    ? 'LATER BUSES'
                                    : 'Later coaches'
                                }`}</button>
                              )}
                          </Fragment>
                        ) : (
                          <div>
                            <div className="service-map">
                              <ServiceMap
                                srv={todayServices}
                                fitbounds={this.state.listDataFromChild}
                                callbackFromParent={this.myCallback}
                                showServiceDetails={this.showServiceDetails}
                                stops={[services.stops[0].metadata]}
                              />
                              </div>
                            </div>
                        )
                      )}
                      {!searchByTicket &&
                        todayServices.length === 0 &&
                        !!futureServices.length && (
                          <div className="no-services">
                            No services found for today, please check the
                            "Tomorrow" tab
                          </div>
                        )}
                        {!searchByTicket &&
                        todayServices.length === 0 &&
                        !!!futureServices.length && (
                          <div className="no-services">
                            No services found for today
                          </div>
                        )}
                          {searchByTicket &&
                              outbound && outbound.length !== 0 && outbound.map((obj, index) => {
                                return (<Service
                                    key={v4()}
                                    service={obj}
                                    showServiceDetails={this.showServiceDetails}
                                    toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                    searchByTicket={true}
                                    showChange={
                                      index < (outbound.length - 1)
                                        ? true
                                        : false
                                    }
                                    future={false}
                                  />);
                            })}
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div
                      className={`${
                        isStops ? 'results--with-live-tracking' : ''
                      }`}
                    >
                      <div className="results__list">
                        <div className="coach-list">
                          <TrackerTitle
                              date={
                                searchByTicket && ticket.legs
                                  && moment(ticket.legs[0].from_stop.scheduled_departure_time_formatted_local).format('DD/MM/YYYY')
                              }
                            >
                            {searchByTicket && !isEmptyObj(ticket)
                              ? `Ticket Number: ${getTicketNumber(history.location.pathname)}`
                              : !THEME.REALTIME ? 'Services' : 'Live Tracking'}
                          </TrackerTitle>
                            {!searchByTicket && !!(services) && (
                            <Fragment>
                              {services.to_stops_metadata && services.to_stops_metadata.length ? (
                                <ServiceTitle>
                                  {services.stops[0].metadata.public_facing_name.substring(
                                    0,
                                    services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                                  )}
                                  <span className="">
                                    {services.stops[0].metadata.public_facing_name.substring(
                                      services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                                    )}
                                  </span>
                                  <span className="to"></span>{' '}
                                  <span>
                                    {services.to_stops_metadata[0].public_facing_name.substring(
                                      0,
                                      services.to_stops_metadata[0].public_facing_name.indexOf(':') + 1
                                    )}
                                    <span className="subName">
                                      {services.to_stops_metadata[0].public_facing_name.substring(
                                        services.to_stops_metadata[0].public_facing_name.indexOf(':') + 1
                                      )}
                                    </span>
                                  </span>
                                </ServiceTitle>
                              ) : services.stops && services.stops.length && services.stops[0].metadata && services.stops[0].metadata.public_facing_name ? (
                                <ServiceTitle>
                                  {services.stops[0].metadata.public_facing_name.substring(
                                    0,
                                    services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                                  )}
                                  <span className="subName">
                                    {services.stops[0].metadata.public_facing_name.substring(
                                      services.stops[0].metadata.public_facing_name.indexOf(':') + 1
                                    )}
                                  </span>
                                </ServiceTitle>
                              ) : match.params.reference ? (
                                <ServiceTitle>
                                  <div>Reference: {match.params.reference}</div>
                                </ServiceTitle>
                              ) : match.params.service ? (
                                <ServiceTitle>
                                  <div>{THEME.SERVICE_SHORT_TEXT ? THEME.SERVICE_SHORT_TEXT : 'Service'}: {match.params.service}</div>
                                </ServiceTitle>
                              ) : (
                                <ServiceTitle>
                                  <div>Not Found</div>
                                </ServiceTitle>
                              )}
                            </Fragment>
                          )}
                        {!searchByTicket &&
                        futureServices.length === 0 && (
                          <div className="no-services">
                            No services found for tomorrow
                          </div>
                        )}

                      {searchByTicket && !isEmptyObj(ticket) && (
                      <ServiceTitle>
                        {inbound && inbound.length ?
                          <Fragment>
                          {
                            inbound[0].from_stop.public_facing_name
                          }{' '}
                          <span className="to"></span>
                          <span>
                            {
                              inbound[0].to_stop.public_facing_name
                            }
                          </span>
                          <Helmet>
                            <title>
                              {THEME.NAME !== 'NX'
                                ? THEME.TITLE
                                : `View Ticket from${' '}
                                ${
                                  inbound[0].from_stop.public_facing_name
                                } to${' '}
                                ${
                                  inbound[0].to_stop.public_facing_name
                                } -
                                National Express Coach Tracker`}
                            </title>
                          </Helmet>
                        </Fragment>  : (
                          'No booked journey'
                        )
                        }
                        </ServiceTitle>)
                        }

                          {!searchByTicket &&
                            !!(
                              futureServices &&
                              futureServices.length
                            ) && (
                              <div style={spaceBetween}>
                                <DateTime
                                  date={moment(services.stops && services.stops.length && (THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id) || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0])) ? services.stops[0].chronological_departures.departure_time_formatted_local : futureServices[0].trip.departure_time_formatted_local).format(
                                    dateFormat
                                  )}
                                />
                                {THEME.SHOW_TABS && ((match.params.service &&
                                  futureDestinations &&
                                  futureDestinations > 1) ||
                                  (futureRoutes &&
                                    futureRoutes.length > 1)) && (
                                  <Dropdown
                                    options={
                                      match.params.service
                                        ? futureDestinations
                                        : futureRoutes
                                    }
                                    onChange={this.filterSelect}
                                    value={this.state.filterValue}
                                    placeholder={
                                      match.params.service
                                        ? 'Filter Destination'
                                        : 'Filter Service'
                                    }
                                  />
                                )}
                              </div>
                            )}

                          <div>
                            {!searchByTicket &&
                              !!futureServices.length && (!THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id) && !THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0]) ?
                              futureServices.map((obj) => (
                                <Service
                                  key={v4()}
                                  service={obj}
                                  showServiceDetails={this.showServiceDetails}
                                  toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                  showChange={
                                    futureServices.length > 1 ? true : false
                                  }
                                  future={true}
                                />
                              ))
                            : 
                            <div>
                              <div className="service-map">
                                <ServiceMap
                                  srv={todayServices}
                                  fitbounds={this.state.listDataFromChild}
                                  callbackFromParent={this.myCallback}
                                  showServiceDetails={this.showServiceDetails}
                                  stops={[services.stops[0].metadata]}
                                />
                              </div>
                            </div>
                          )}

                            {searchByTicket &&
                              inbound && inbound.length !== 0 && inbound.map((obj, index) => {
                                  return (<Service
                                      key={v4()}
                                      service={obj}
                                      showServiceDetails={this.showServiceDetails}
                                      toggleCancelledInfoModal={this.toggleCancelledInfoModal}
                                      searchByTicket={true}
                                      showChange={
                                        index < (inbound.length - 1)
                                          ? true
                                          : false
                                      }
                                      future={false}
                                    />);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              )}

              {<div
                className={`results__details ${
                  services.stops && services.stops.length && (THEME.HIGH_FREQUENCY_SERVICES.includes(services.stops[0].chronological_departures[0].trip.route_id || THEME.HIGH_FREQUENCY_SERVICES_STARTS.includes(services.stops[0].chronological_departures[0].trip.route_id[0])))
                    ? 'results__details--highfrequency'
                    : ''
                  } ${
                  history.location.pathname.indexOf('route') !== -1
                    ? 'results__details--route'
                    : ''
                }`}
                style={
                  showTabs && isMobileScreen.open
                    ? { display: 'none' }
                    : { display: 'block' }
                }
              >
                <Route
                  path={
                    searchByTicket
                      ? '/ticket/:hash/:ticketId/:from/:to/route/:route/:dir/:journeyId/:linkDate'
                      : history.location.pathname.indexOf('debug-trip') !== -1
                      ? '/view/debug-trip/route/:route/:dir/:journeyId/:linkDate'
                      : match.params.reference
                      ? '/view/reference/:reference/route/:route/:dir/:journeyId/:linkDate'
                      : match.params.service
                      ? '/view/service/:service/route/:route/:dir/:journeyId/:linkDate'
                      : match.params.stop
                      ? '/view/stop/:stop/route/:route/:dir/:journeyId/:linkDate'
                      : '/view/between/:from/:to/route/:route/:dir/:journeyId/:linkDate'
                  }
                  render={(props) => (
                    <ServiceDetails
                      {...props}
                      showMap={this.props.showMap}
                      service={this.state}
                      toggleInfoModal={this.toggleInfoModal}
                      toggleFreqInfoModal={this.toggleFreqInfoModal}
                      callbackFromParent={this.myCallback}
                      detailsTabIndex={this.state.detailstabindex}
                      showStops={this.showStops}
                    />
                  )}
                />

                <Route
                  path={[
                    '/view/between/:from/:to',
                    '/view/reference/:reference',
                    '/view/service/:service',
                    '/view/stop/:stop',
                    '/view/debug-trip',
                  ]}
                  exact
                  render={(props) => (
                    <div className="live-tracking-empty">
                      {getLogoBackground(THEME.NAME) && (
                        <img src={getLogoBackground(THEME.NAME)} alt="Empty" />
                      )}
                    </div>
                  )}
                />
              </div>}
            </div>
          </div>
        )}

        {!isShowSearch && (
          <div className="tracker-map-container">
            <TopBar
              title="Close Map"
              onClick={this.props.hideMap}
              className="navlink--map"
            />
            <div className="tracker-map">
              <h3>Map View</h3>
              {station.stops && station.stops.length ? (
                <StopsMap
                  stops={station.stops}
                  tracking={station.tracking}
                  active_vehicle={station.active_vehicle}
                  trip={station.trip}
                  traffic_incidents={station.traffic_incidents}
                  coachtracker={station.coachtracker}
                  fitbounds={this.state.listDataFromChild}
                  callbackFromParent={this.myCallback}
                />
              ) : null}
            </div>
          </div>
        )}
        <Modal
          shouldCloseOnOverlayClick={true}
          isOpen={isFreqInfoModalOpen}
          onRequestClose={this.closeModal}
          style={stylesModal}
        >
          <div className="modal">
            <h3 className="modal__title">
              High frequency route
              <img
                className="modal__close"
                src={getCloseIcon(THEME.NAME)}
                alt="Icon close"
                onClick={this.closeModal}
              />
            </h3>
            This is a high frequency service, this means you are able to board any coach to the Airport with your ticket. Please note this is subject to seat availability
          </div>
        </Modal>

        <Modal
          shouldCloseOnOverlayClick={true}
          isOpen={isCancelledInfoModalOpen}
          onRequestClose={this.closeModal}
          style={stylesModalInfo}
        >
          <div className="modal">
            <h3 className="modal__title">
              Service not trackable
              <img
                className="modal__close"
                src={getCloseIcon(THEME.NAME)}
                alt="Icon close"
                onClick={this.closeModal}
              />
            </h3>
            This service is not trackable. Please refer to the timetable. If your service is more than 15 minutes late, then please call our&nbsp;
            {THEME.CONTACT_URL ? <a
              href={THEME.CONTACT_URL}
              target="_blank"
              rel="noreferrer"
            >
              {'customer service team'}
            </a> : 'customer service team'}
            &nbsp;for further information.
            <br />
          </div>
        </Modal>
        
        <Modal
          shouldCloseOnOverlayClick={true}
          isOpen={isInfoModalOpen}
          onRequestClose={this.closeModal}
          style={stylesModal}
        >
          <div className="modal">
            <h3 className="modal__title">
              Journey Information
              <img
                className="modal__close"
                src={getCloseIcon(THEME.NAME)}
                alt="Icon close"
                onClick={this.closeModal}
              />
            </h3>

            {station && station.trip && (
              <ul className="modal__info">
                <li>{station.trip.class_name}</li>
                <li>{THEME.SERVICE_SHORT_TEXT ? THEME.SERVICE_SHORT_TEXT : 'Service'}: {station.trip.route_id}</li>
                <li>
                  Duration:{' '}
                  {
                      calculateDuration(
                        null,
                        null,
                        station.stops,
                        fromStop ? fromStop.scheduled_departure_time_formatted_local : station.trip.departure_time_formatted_local,
                        toStop ? toStop.scheduled_arrival_time_formatted_local : station.trip.arrival_time_formatted_local
                      )
                  }{' '}
                </li>
              </ul>
            )}

            <div className="modal__direction">
              <div className="cell">
                <div className="cell__circle"></div>
                <div className="cell__circle"></div>
              </div>
              <div>
                <p>
                  {currDate}
                  <br />
                  {searchByTicket &&
                    !!Object.keys(ticket).length &&
                    getTicketNumber(history.location.pathname)}
                  {!searchByTicket &&
                    !!Object.keys(station).length && (
                        <Fragment>
                          <b>
                            {
                              getStopName(
                                  fromStop.name
                              )[0]
                            }
                          </b>
                          <br />
                          <span style={{ fontSize: 12 }}>
                            {getStopName(
                                fromStop.name
                              ).length > 1
                                ? getStopName(
                                  fromStop.name
                                  )[1]
                                : null}
                          </span>
                        </Fragment>
                      )}

                  <br />
                  <span>
                    Departs:{' '}
                    {fromStop &&
                      getTime(
                        fromStop.scheduled_departure_time_formatted_local
                      )}
                  </span>
                </p>
                <p>
                  {searchByTicket &&
                    !!Object.keys(ticket).length &&
                    getTicketNumber(history.location.pathname)}
                  {!searchByTicket &&
                    !!Object.keys(station).length && (
                        <Fragment>
                          <b>
                            {
                              getStopName(
                                toStop.name
                              )[0]
                            }
                          </b>
                          <br />
                          <span style={{ fontSize: 12 }}>
                            {getStopName(
                              toStop.name
                            ).length > 1
                              ? getStopName(
                                toStop.name
                                )[1]
                              : null}
                          </span>
                        </Fragment>
                      )}
                  <br />
                  <span>
                    Arrives:{' '}
                    {station && station.trip &&
                      getTime(
                        toStop.scheduled_arrival_time_formatted_local
                      )}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Modal>

        {(THEME.SHOW_SOCIAL_BUTTONS && !embed && <StickyShareButtons
          config={{
            alignment: 'left',
            color: 'social',
            enabled: true,
            font_size: 16,
            hide_desktop: false,
            labels: 'counts',
            language: 'en',
            min_count: 10,
            networks: ['facebook', 'twitter', 'email', 'messenger', 'whatsapp'],
            padding: 12,
            radius: 4,
            show_total: true, // show/hide the total share count (true, false)
            show_mobile: true, // show/hide the buttons on mobile (true, false)
            show_toggle: true, // show/hide the toggle buttons (true, false)
            size: 48,
            top: 160,
          }}
        />)}
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, {
  fetchServices,
  fetchTicketInfo,
})(ServiceList);



// WEBPACK FOOTER //
// ./src/containers/ServiceList.js